<div class="box {{type()}} {{mode()}}" [style.margin-bottom]="marginBottom()" [style.padding]="padding() + 'px'" >
    <ng-content />
</div>
